import { map, mergeRight, path, prop, sortBy, toPairs } from "ramda";

export const Fields = {
  age_range: {
    value: "age_range",
    display: "Age Range",
    defaultValueAllowed: false,
  },

  audience: {
    value: "audience",
    display: "Audience",
    defaultValueAllowed: true,
  },

  contributor_corporation_name: {
    value: "contributor_corporation_name",
    display: "Corporation Name",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  contributor_corporation_option: {
    value: "contributor_corporation_option",
    display: "Contributor Corporation Option",
    defaultValueAllowed: false,
  },

  contributor_first_name: {
    value: "contributor_first_name",
    display: "Contributor First",
    defaultValueAllowed: true,
  },

  contributor_last_name: {
    value: "contributor_last_name",
    display: "Contributor Last",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  contributor_middle_name: {
    value: "contributor_middle_name",
    display: "Contributor Middle",
    defaultValueAllowed: true,
  },

  contributor_prefix: {
    value: "contributor_prefix",
    display: "Contributor Prefix",
    defaultValueAllowed: true,
  },

  contributor_role: {
    value: "contributor_role",
    display: "Contributor Role",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  contributor_suffix: {
    value: "contributor_suffix",
    display: "Contributor Suffix",
    defaultValueAllowed: true,
  },

  contributor_twitter_handle: {
    value: "contributor_twitter_handle",
    display: "Contributor X handle",
    defaultValueAllowed: false,
  },

  contributor_website: {
    value: "contributor_website",
    display: "Contributor Website",
    defaultValueAllowed: false,
  },

  contributors: {
    value: "contributors",
    display: "Contributors",
    defaultValueAllowed: false,
  },

  corporation_name: {
    value: "corporation_name",
    display: "Corporation Name",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  country: {
    value: "country",
    display: "Country",
    defaultValueAllowed: true,
  },

  custom_dropdown: {
    value: "custom_dropdown",
    display: "Custom Dropdown",
    defaultValueAllowed: true,
  },

  custom_freeform: {
    value: "custom_freeform",
    display: "Custom Freeform",
    defaultValueAllowed: true,
  },

  custom_freeform_2: {
    value: "custom_freeform_2",
    display: "Custom Freeform 2",
    defaultValueAllowed: true,
  },

  description: {
    value: "description",
    display: "Description",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  edition: {
    value: "edition",
    display: "Edition",
    defaultValueAllowed: true,
  },

  email: {
    value: "email",
    display: "Email",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  episode: {
    value: "episode",
    display: "Episode",
    defaultValueAllowed: true,
  },

  first_name: {
    value: "first_name",
    display: "First Name",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  freeform_personal_data: {
    value: "freeform_personal_data",
    display: "Freeform Personal Data",
    defaultValueAllowed: true,
  },

  freeform_personal_data_2: {
    value: "freeform_personal_data_2",
    display: "Freeform Personal Data 2",
    defaultValueAllowed: true,
  },

  isbn: {
    value: "isbn",
    display: "ISBN",
    defaultValueAllowed: false,
  },

  keywords: {
    value: "keywords",
    display: "Keywords",
    defaultValueAllowed: true,
  },

  language: {
    value: "language",
    display: "Language",
    defaultValueAllowed: true,
  },

  last_name: {
    value: "last_name",
    display: "Last Name",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  license_type: {
    value: "license_type",
    display: "License Type",
    defaultValueAllowed: true,
  },

  local_library: {
    value: "local_library",
    display: "Local Library",
    defaultValueAllowed: true,
  },

  local_library_other: {
    value: "local_library_other",
    display: "Local Library Other",
    defaultValueAllowed: true,
  },

  locality: {
    value: "locality",
    display: "City",
    defaultValueAllowed: true,
  },

  middle_name: {
    value: "middle_name",
    display: "Middle Name",
    defaultValueAllowed: true,
  },

  pod_vendor: {
    value: "pod_vendor",
    display: "Publish on Demand (POD) vendor (optional)",
    defaultValueAllowed: true,
  },

  prefix: {
    value: "prefix",
    display: "Prefix",
    defaultValueAllowed: true,
  },

  publication_date: {
    value: "publication_date",
    display: "Publication Date",
    defaultValueAllowed: true,
  },

  publication_year: {
    value: "publication_year",
    display: "Publication Year",
    defaultValueAllowed: true,
  },

  publisher_name: {
    value: "publisher_name",
    display: "Publisher Name",
    defaultValueAllowed: true,
  },

  rating: {
    value: "rating",
    display: "Rating",
    defaultValueAllowed: true,
  },

  region: {
    value: "region",
    display: "State or province",
    defaultValueAllowed: true,
  },

  role: {
    value: "role",
    display: "Role",
    defaultValueAllowed: false,
    alwaysRequired: true,
  },

  series: {
    value: "series",
    display: "Series",
    defaultValueAllowed: true,
  },

  sub_projects: {
    value: "sub_projects",
    display: "Sub Projects",
    defaultValueAllowed: true,
  },

  subtitle: {
    value: "subtitle",
    display: "Subtitle",
    defaultValueAllowed: true,
  },

  suffix: {
    value: "suffix",
    display: "Suffix",
    defaultValueAllowed: true,
  },

  terms_header_other_considerations: {
    value: "terms_header_other_considerations",
    display: "Terms Header (Other Considerations)",
  },

  title: {
    value: "title",
    display: "Title",
    defaultValueAllowed: true,
    alwaysRequired: true,
  },

  twitter_handle: {
    value: "twitter_handle",
    display: "X Handle",
    defaultValueAllowed: false,
  },

  volume: {
    value: "volume",
    display: "Volume",
    defaultValueAllowed: true,
  },

  website: {
    value: "website",
    display: "Website",
    defaultValueAllowed: false,
  },
};

export const getFieldNameDisplay = fieldName =>
  path([fieldName, "display"], Fields);

export const fieldOptionAllowed = (fieldName, option) =>
  path([fieldName, `${option}Allowed`], Fields);

export const alwaysRequired = fieldName =>
  path([fieldName, "alwaysRequired"], Fields);

export const defaultValueAllowed = fieldName =>
  path([fieldName, "defaultValueAllowed"], Fields);

export const getFieldOptionNames = () =>
  sortBy(
    prop("display"),
    map(x => mergeRight(x[1], { name: x[0] }), toPairs(Fields)),
  );
